import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import axios from "axios";
import { Card } from 'primereact/card';
const apiUrl = process.env.REACT_APP_API_URL;

export function ListCat() {
  const [categories, setCategories] = useState([]);
  const toast = useRef(null);

  useEffect(() => {
    fetch(`${apiUrl}IHM/api/zotCategorie.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCategories(data.categories);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const onRowReorder = async (e) => {
    const newOrder = e.value.map((item, index) => ({
      idtally: item.idtally,
      ordre: index + 1,
    }));

    setCategories(e.value);

    try {
      await axios.post(`${apiUrl}IHM/api/postUpdate/updateCategorieOrder.php`, {
        order: newOrder,
      });
      window.location.reload();
    } catch (error) {
      
    }
  };

  const toggleAfficher = async (rowData, value) => {
    const updatedCats = categories.map((cat) =>
      cat.idtally === rowData.idtally
        ? { ...cat, afficher_admin: value ? 1 : 0 }
        : cat
    );
    setCategories(updatedCats);

    try {
      await axios.post(`${apiUrl}IHM/api/postUpdate/updateCategorieAfficher.php`, {
        idtally: rowData.idtally,
        afficher_admin: value ? 1 : 0,
      });

      window.location.reload();
      
    } catch (error) {
   
    }
  };


   const toggleVueGlobale = async (rowData, value) => {
    const updatedCats = categories.map((cat) =>
      cat.idtally === rowData.idtally
        ? { ...cat, vue_globale: value ? 1 : 0 }
        : cat
    );
    setCategories(updatedCats);

    try {
      await axios.post(`${apiUrl}IHM/api/postUpdate/updateVueGlobale.php`, {
        idtally: rowData.idtally,
        vue_globale: value ? 1 : 0,
      });

      window.location.reload();
    
    } catch (error) {
      
    }
  };


const toggleSite = async (rowData, value) => {
const updatedCats = categories.map((cat) =>
      cat.idtally === rowData.idtally
        ? { ...cat, afficher_site: value ? 1 : 0 }
        : cat
    );
    setCategories(updatedCats);

  try {
      await axios.post(`${apiUrl}IHM/api/postUpdate/updateAfficherSite.php`, {
        idtally: rowData.idtally,
        afficher_site: value ? 1 : 0,
      });

      window.location.reload();
    
    } catch (error) {
      
    }
};


  const header = (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <h3>Catégories</h3>
    </div>
  );
  if (
    localStorage.getItem("us") === "admin" ||
    localStorage.getItem("us") === "dev"
  ) {
    return (
      <>
        <DataTable
          value={categories}
          rows={25}
          size="small"
          header={header}
          dataKey="idtally"
          paginator
          reorderableRows
          onRowReorder={onRowReorder}
          tableStyle={{ minWidth: "50rem" }}
          rowsPerPageOptions={[5, 8, 10, 25, 50]}
          scrollable
          scrollDirection="horizontal"
          paginatorTemplate={
            "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
          }
          emptyMessage="Aucune catégorie pour le moment"
          paginatorRight={
            <span style={{ margin: "10px", fontWeight: "bold" }}>
              Résultats : {categories.length}
            </span>
          }
        >
          <Column rowReorder headerStyle={{ width: "3rem" }} />
          <Column field="idtally" header="ID" />
          <Column field="title" header="Catégorie" style={{ width: "30%" }} />
          <Column field="url" header="URL" />
          <Column field="nb" header="Projets" /> 
          
          <Column
            field="afficher_site"
            header="Site"
            style={{ textAlign: "center", width: "120px" }}
            body={(rowData) => (
            <Checkbox 
            checked={rowData.afficher_site == 1}
            onChange={(e) => toggleSite(rowData, e.checked)}
            />
          )
            }
          />
          <Column
            field="afficher_admin"
            header="Suivi"
            style={{ textAlign: "center", width: "120px" }}
            body={(rowData) => (
              <Checkbox
                checked={rowData.afficher_admin == 1}
                onChange={(e) => toggleAfficher(rowData, e.checked)}
              />
            )}
          />

          <Column
            field="vue_globale"
            header="Vue globale"
            style={{ textAlign: "center", width: "120px" }}
            body={(rowData) => (
              <Checkbox
                checked={rowData.vue_globale == 1}
                onChange={(e) => toggleVueGlobale(rowData, e.checked)}
              />
            )}
          />
        </DataTable>
      </>
    );
  } else {
    return (
      <div
        className="p-d-flex p-jc-center p-ai-center"
        style={{ height: "100vh" }}
      >
        <Card title="Page Non Disponible" className="p-shadow-3">
          <div className="p-text-center">
            <p>
              Nous sommes désolés, mais la page que vous cherchez n'est pas
              disponible.
            </p>
          </div>
        </Card>
      </div>
    );
  }
}
